﻿"use strict";

/* @preserve
// ------------------------------------------
// Login JS
// ------------------------------------------
*/

// Global Variables
// ------------------------------------------
if (document.body.classList.contains("local")) {
    window.localSide = true;
    window.developmentSide = true;
}

// CapsLocks.JS - [code.iamkate.com] - CC0 1.0 Universal
const CapsLock = function(){var e=/Mac/.test(navigator.platform),b=!1,d=[];window.addEventListener("keypress",function(a){var c=a.charCode;a=a.shiftKey;var f=b;97<=c&&122>=c?b=a:!(65<=c&&90>=c)||a&&e||(b=!a);b!==f&&d.forEach(function(a){return a(b)})});return{isOn:function(){return b},addListener:function(a){d.push(a)}}}();

(async () => { 
	// Cached Variables
	const form = document.getElementById("login-form");
	const loginAlert = document.getElementById("login-alert");
	const passwordInput = document.getElementById("password");
	const DisplayLoginError = errorMsg => {
		// Display Error Message Alert
		// ------------------------------------------
		// [errorMsg] {@STRING} - Required. The error message string/HTML.
		// ------------------------------------------
		loginAlert.style.display = "none";
		loginAlert.classList.remove("d-none");
		loginAlert.querySelector(".login-alert-inner").textContent = errorMsg;
		passwordInput.value = "";
		passwordInput.focus();
		$(passwordInput).valid();
		$.Velocity(loginAlert, "slideDown", {
			duration: "fast",
			complete: () => {
				$.Velocity(document.body, "scroll", {
					easing: "spring",
					offset: loginAlert.getBoundingClientRect().top + document.body.scrollTop - 10,
					mobileHA: false
				});
			}
		});
	};

    // Get the version number.
    // ------------------------------------------
    const versionNumber = document.body.getAttribute("data-version");
    window.version = versionNumber;

	// Remove the "no-js" class from the HTML document.
	// ------------------------------------------
	document.documentElement.classList.remove("no-js");

	// Google Analytics
    // ------------------------------------------
    await FLPPR_loader("https://www.googletagmanager.com/gtag/js?id=G-LVVLE17TCD",null,false,"js");
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-LVVLE17TCD');

	// Show a warning if caps lock is on.
	let capslockPopoverShown = false;
	const passwordPopover = $(passwordInput);
	passwordPopover.popover({
		content: "<i class=\"fa fa-exclamation-triangle mr-2\" aria-hidden=\"true\"></i>Caps Lock is on",
		trigger: "manual",
		placement: "right",
		fallbackPlacement: ["right","top"],
		sanitize: false,
		html: true,
		template: '<div class="popover popover-danger" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
	});
	CapsLock.addListener(isOn => {
		if (isOn && capslockPopoverShown === false) {
			passwordPopover.popover("show");
			capslockPopoverShown = true;
		} else if (!isOn && capslockPopoverShown === true) {
			passwordPopover.popover("hide");
			capslockPopoverShown = false;
		}
	});

	// Ladda
	// Stop Ladda when leaving the page - used to make sure it's not still running when users hit the back button.
	// ------------------------------------------
    await FLPPR_loader(`/node_modules/ladda/dist/spin.min.js?version=${window.version}`);
    await FLPPR_loader(`/node_modules/ladda/dist/ladda.min.js?version=${window.version}`);
	Ladda.bind("button.btn.ladda-button");
	window.addEventListener("pagehide", e => { if (typeof Ladda === "object") { Ladda.stopAll(); } });

	// Initial focus
	// ------------------------------------------
	document.getElementById("username").focus();

	// Reenable the submit button.
	// ------------------------------------------
	form.querySelector('button[type="submit"]').disabled = false;

	// AJAX Submit & Validation
	// ------------------------------------------
	$(form).validate({
		submitHandler: async (formElement,e) => {
			e.preventDefault();
			const response = await fetch(form.action, {
				credentials: "same-origin",
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded"
				},
				body: new URLSearchParams({
					"username": document.getElementById("username").value,
					"password": document.getElementById("password").value,
					"remember": document.getElementById("remember").checked ? "True" : "",
					"T": document.getElementById("T").value,
					"S": document.getElementById("S").value
				})
			});
			if (response.ok) {
				const responseJSON = await response.json();
				switch (responseJSON.status.trim().toUpperCase()) {
					case "SUCCESS":
						// Success
						window.location = responseJSON.redirecturl;
						break;
					default:
						// Error
						DisplayLoginError(responseJSON.statusmessage);
						Ladda.stopAll();
						break;
				}
			} else {
				console.warn('AJAX Error: ' + response + ' (500)'); 
				DisplayLoginError(response);
				Ladda.stopAll(); 
			}
		},
		rules: {
			username: { required: true },
			password: {required: true,minlength: 3}
		},
		messages: {
			username: { required: "Please enter your email address" },
			password: {required: "Please enter your password"}
		},
		invalidHandler: (form, validator) => {
			if (validator.numberOfInvalids()) {
				if (console.groupCollapsed !== undefined) {
					console.groupCollapsed("[Validation] Errors: [", Object.keys(validator.errorMap).length, "]");
				} else {
					console.warn("[Validation] Errors: [", Object.keys(validator.errorMap).length, "]");
				}
				let errorCount = 1;
				for (let i in validator.errorMap) { 
					console.warn("#" + errorCount + " - ", i, ":", validator.errorMap[i], "Element: ", validator.errorList[0].element); 
					++errorCount; 
				}
				if (console.groupCollapsed !== undefined) { console.groupEnd(); }
				Ladda.stopAll();
			}
		}
	});

	// Load the modal plugin and all associated files.
	// This is so we can display the privacy policy/terms of use buttons.
	// ------------------------------------------
	if (window.localSide === true) {
		await FLPPR_loader("/SharedResources/js/src/FLPPR/js/FLPPR-utilities.js");
		await FLPPR_loader("/SharedResources/js/src/FLPPR/js/FLPPR-loadingspinner.js");
		await FLPPR_loader("/SharedResources/js/src/FLPPR/js/FLPPR-modal.js");
	} else {
        await FLPPR_loader(`/SharedResources/js/dist/FLPPR/js/FLPPR-utilities.min.js?version=${window.version}`);
        await FLPPR_loader(`/SharedResources/js/dist/FLPPR/js/FLPPR-loadingspinner.min.js?version=${window.version}`);
        await FLPPR_loader(`/SharedResources/js/dist/FLPPR/js/FLPPR-modal.min.js?version=${window.version}`);
	}
	// Loading Spinner
    FLPPR_loadingspinner.init({ 
        debug: window.localSide 
    });
	// Modals
	await FLPPR_modal.init({
		debug: false,
		bootstrapVersion: 4,
		alignment: "center",
		pathPrefix: ""
	});

	// Open the "Privacy Policy" modal.
	// ------------------------------------------
	$(document).on("click",".btn-privacypolicy",e => {
		FLPPR_modal.load({
			title: "Privacy Policy",
			source: "login/modals/modal-privacypolicy",
			script: false
		});
		e.preventDefault();
	});

	// Open the "Terms of Use" modal.
	// ------------------------------------------
	$(document).on("click",".btn-termsofuse",e => {
		FLPPR_modal.load({
			title: "Terms of Use",
			source: "login/modals/modal-termsofuse",
			script: false
		});
		e.preventDefault();
	});

	// Open the "About" modal.
	// ------------------------------------------
	$(document).on("click",".btn-about",e => {
		FLPPR_modal.load({
			title: "About",
			source: "about/about"
		});
		e.preventDefault();
	});

	// Un-disable the buttons.
	// ------------------------------------------
	document.querySelector(".btn-privacypolicy").removeAttribute("disabled");
	document.querySelector(".btn-termsofuse").removeAttribute("disabled");
	document.querySelector(".btn-about").removeAttribute("disabled");
})();